/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.minicart-product-list');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(function () {
  	jQuery('.shopping__cart').removeClass("shopping__cart__on");
    jQuery('.body__overlay').removeClass("is-visible");
  },2000);
}

Shopify.addItem = function(variant_id, quantity, callback){
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id, callback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    beforeSend: function(){
      if(form_id == "add-item-qv") {
        jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
      }
    },
    data: jQuery('#' + form_id).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        if(form_id != "add-item-qv") {
          Shopify.cartPopapForm(variant_id, line_item);
        } else {
          	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
            jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
            setTimeout(function(){
              	jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
            	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
            }, 2000);
          }
          Shopify.onItemAdded(line_item);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        if(form_id != "add-item-qv") {
          Shopify.onError(XMLHttpRequest, textStatus);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
          setTimeout(function(){
            jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      }
    };
    jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(variant_id) {
  	var image = jQuery('.'+variant_id+':first .popup_cart_image').attr("data-srcset");
  	var title = jQuery('.'+variant_id+':first .popup_cart_title').text();
   // var propPrice = jQuery('#product_current_price').text();
  	jQuery('.popupimage').attr("src",''+image+'');
  	jQuery('.productmsg').html(title);  
    //jQuery('.pop_current_price').text('"'+ propPrice +'"');
  	jQuery('#modalAddToCart').modal("toggle");
}
Shopify.cartPopapForm = function(variant_id, line_item) {
  var image = line_item.image;
  var title = line_item.title;

  console.log('Image3:', image);
  console.log('Title:', title);

  jQuery('.popupimage').attr("src", image);
  jQuery('.productmsg').html(title);
  jQuery('#modalAddToCart').modal("toggle");
}

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = "<span class='money'>€{{amount}}</span>";
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {
      cart_cell.empty();
      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
          
          if (value.length) {
            jQuery(".cart-box-product").css({"display": "block"});
            jQuery(".cart-empty-title").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery('<li><a href="' + item.url + '" class="image"><img src="' + item.image + '" alt="Cart product Image"></a><div class="content"><a href="' + item.url + '" class="title">' + item.title + '</a><span class="quantity-price">' + item.quantity + ' x <span class="amount">' + Shopify.formatMoney(item.price, formatMoney) + '</span></span><a href="javascript:void(0);" class="remove" onclick="Shopify.removeItem(' + item.variant_id + ')">×</a></div></li>').appendTo(table);
            });
          }
          else {
            jQuery(".cart-box-product").css({"display": "none"});
            jQuery(".cart-empty-title").css({"display": "block"});
          }
        }
      });

      
    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);

  jQuery('.currency .active').trigger('click');
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};

document.addEventListener('DOMContentLoaded', function() {
  initGiftWrapFunctionality();
});

function initGiftWrapFunctionality() {
  const giftWrapCheckbox = document.getElementById('add-gift-wrap');
  const giftWrapId = '46523124089082'; // Gift wrap product ID

  function toggleGiftWrap(checked, productId = null) {
    console.log('toggleGiftWrap called with checked:', checked, 'for product:', productId);
    if (checked) {
      addGiftWrap(productId);
    } else {
      removeGiftWrap(productId);
    }
  }

  function addGiftWrap(productId) {
    const item = { id: giftWrapId, quantity: 1 };
    if (productId) item.properties = { _associated_product: productId };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Gift wrap added successfully', data);
      updateCart();
    })
    .catch(error => console.error('Error:', error));
  }

  function removeGiftWrap(productId) {
    const body = { id: giftWrapId, quantity: 0 };
    if (productId) body.properties = { _associated_product: productId };

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Gift wrap removed successfully', data);
      updateCart();
    })
    .catch(error => console.error('Error:', error));
  }

  function updateCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('Cart updated', cart);
        refreshGiftWrapCheckboxes();
      })
      .catch(error => console.error('Error:', error));
  }

  function refreshGiftWrapCheckboxes() {
    const cartItems = document.querySelectorAll('.cart-box-product li');
    cartItems.forEach(item => {
      const productId = item.getAttribute('data-product-id');
      if (productId && productId !== giftWrapId) {
        let checkbox = item.querySelector('.gift-wrap-cart-option');
        if (!checkbox) {
          checkbox = document.createElement('div');
          checkbox.className = 'gift-wrap-cart-option';
          checkbox.innerHTML = `
            <input type="checkbox" id="gift-wrap-${productId}" name="attributes[Gift Wrap ${productId}]" value="Yes" data-product-id="${productId}">
            <label for="gift-wrap-${productId}">Add gift bag (+€1.50)</label>
          `;
          item.appendChild(checkbox);
        }
      }
    });
    addGiftWrapListeners();
  }

  function addGiftWrapListeners() {
    const giftWrapCartCheckboxes = document.querySelectorAll('[id^="gift-wrap-"]');
    giftWrapCartCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        const productId = this.getAttribute('data-product-id');
        toggleGiftWrap(this.checked, productId);
      });
    });
  }

  if (giftWrapCheckbox) {
    giftWrapCheckbox.addEventListener('change', function() {
      toggleGiftWrap(this.checked);
    });
  }

  refreshGiftWrapCheckboxes();
}
